class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="radio"]');
    this.inputs.forEach(input => {
      input.addEventListener('change', this.onInputChange.bind(this));
    });

    // Fix mobile double tap
    this.querySelectorAll('label').forEach(label => {
      label.addEventListener('touchend', (e) => {
        e.preventDefault();
        const input = document.getElementById(label.getAttribute('for'));
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  onInputChange(event) {
    const input = event.target;
    const quantity = input.value;
    
    const qtyInput = document.querySelector('.t4s-form__product input[name="quantity"]');
      
    if (qtyInput) {
      qtyInput.value = quantity;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

if (!customElements.get('quantity-breaks')) {
  customElements.define('quantity-breaks', QuantityBreaks);
}

document.addEventListener('t4s:section:load', function() {
  document.querySelectorAll('quantity-breaks').forEach(el => el.connectedCallback());
});

document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('quantity-breaks').forEach(el => el.connectedCallback());
});